import React, { Fragment } from 'react';
import { FormattedNumber, FormattedDate } from 'react-intl';
import Translate from '../../../components/Translate';

export var ExpandedBonusTable = function ExpandedBonusTable(_ref) {
  var item = _ref.item,
      isSiblingEven = _ref.isSiblingEven;

  var TableRowClasses = 'expanded-bonus-row' + (isSiblingEven ? ' sibling-is-even' : '');

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      'tr',
      { className: TableRowClasses },
      React.createElement(
        'td',
        null,
        React.createElement(Translate, { id: 'table.Type', defaultMessage: 'Type' }),
        React.createElement(
          'p',
          null,
          item.Type
        )
      ),
      React.createElement(
        'td',
        null,
        React.createElement(Translate, { id: 'table.Amount', defaultMessage: 'Amount' }),
        React.createElement(
          'p',
          null,
          item.Amount
        ),
        React.createElement(
          'p',
          null,
          item.Currency
        )
      )
    ),
    React.createElement(
      'tr',
      { className: TableRowClasses },
      React.createElement(
        'td',
        null,
        React.createElement(Translate, { id: 'table.Id', defaultMessage: 'ID' }),
        React.createElement(
          'p',
          null,
          item.Id
        )
      ),
      React.createElement(
        'td',
        null,
        React.createElement(Translate, { id: 'table.Bonus', defaultMessage: 'Bonus' }),
        React.createElement(
          'p',
          null,
          item.Name
        )
      )
    ),
    React.createElement(
      'tr',
      { className: TableRowClasses },
      React.createElement(
        'td',
        null,
        React.createElement(Translate, { id: 'table.Date', defaultMessage: 'Date' }),
        React.createElement(
          'p',
          { className: 'date' },
          React.createElement(FormattedDate, {
            value: item.Expires,
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long',
            className: 'date'
          })
        )
      )
    )
  );
};

export var BonusTableRow = function BonusTableRow(_ref2) {
  var item = _ref2.item,
      onExpand = _ref2.onExpand,
      evenTableRow = _ref2.evenTableRow,
      active = _ref2.active;

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      'tr',
      {
        onClick: onExpand,
        className: 'bonus-row' + (evenTableRow && ' even-bonus-row' || '') + ' ' + (active && 'active' || ''),
        key: item.Id },
      React.createElement(
        'td',
        null,
        item.Description
      ),
      React.createElement(
        'td',
        null,
        (100 - item.WageringRequirmentRemaining / item.WageringRequirment * 100 || 0).toFixed(2),
        '% / 100%'
      ),
      React.createElement(
        'td',
        null,
        React.createElement(FormattedNumber, {
          value: item.Amount,
          style: item.Type.toLowerCase() == 'freespins' ? 'decimal' : 'currency',
          currency: item.Currency
        })
      )
    )
  );
};

export var BonusTableHeader = function BonusTableHeader() {
  return React.createElement(
    'tr',
    { className: 'table-header' },
    React.createElement(
      'td',
      null,
      React.createElement(Translate, { id: 'bonus.table.header.method', defaultMessage: 'Method' })
    ),
    React.createElement(
      'td',
      null,
      React.createElement(Translate, { id: 'bonus.table.header.wagering', defaultMessage: 'Wagering' })
    ),
    React.createElement(
      'td',
      null,
      React.createElement(Translate, { id: 'bonus.table.header.amount', defaultMessage: 'Amount' })
    )
  );
};

export var TableMobileRow = function TableMobileRow(_ref3) {
  var data = _ref3.data;

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      'tr',
      { className: 'history-highlight-item' },
      React.createElement(
        'th',
        null,
        '#'
      ),
      React.createElement(
        'td',
        null,
        data.Id
      )
    ),
    React.createElement(
      'tr',
      null,
      React.createElement(
        'th',
        null,
        React.createElement(Translate, {
          defaultMessage: 'label.bonus_table_name',
          id: 'label.bonus_table_name'
        })
      ),
      React.createElement(
        'td',
        null,
        data.Description
      )
    ),
    React.createElement(
      'tr',
      null,
      React.createElement(
        'th',
        null,
        React.createElement(Translate, {
          defaultMessage: 'label.bonus_table_type',
          id: 'label.bonus_table_type'
        })
      ),
      React.createElement(
        'td',
        null,
        React.createElement(Translate, {
          defaultMessage: 'label.type.bonus.' + data.Type.toLowerCase(),
          id: 'label.type.bonus.' + data.Type.toLowerCase()
        })
      )
    ),
    React.createElement(
      'tr',
      null,
      React.createElement(
        'th',
        null,
        React.createElement(Translate, {
          defaultMessage: 'label.bonus_table_amount',
          id: 'label.bonus_table_amount'
        })
      ),
      React.createElement(
        'td',
        null,
        React.createElement(FormattedNumber, {
          value: data.Amount,
          style: 'currency',
          currency: data.Currency
        })
      )
    ),
    React.createElement(
      'tr',
      null,
      React.createElement(
        'th',
        null,
        React.createElement(Translate, {
          defaultMessage: 'label.bonus_table_wagering',
          id: 'label.bonus_table_wagering'
        })
      ),
      React.createElement(
        'td',
        null,
        (100 - data.WageringRequirmentRemaining / data.WageringRequirment * 100 || 0).toFixed(2),
        '% / 100%'
      )
    )
  );
};